import type { LucideIcon } from "lucide-react";

import { cn } from "@/lib/cn";

/** The one control that opens, closes or widens a Lab side panel: a large sidebar icon, named by its tooltip. */
export function LabPanelToggle({
  label,
  icon: Icon,
  onClick,
  pressed,
  className,
}: {
  label: string;
  icon: LucideIcon;
  onClick: () => void;
  pressed?: boolean;
  className?: string;
}) {
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      aria-pressed={pressed}
      onClick={onClick}
      className={cn(
        "inline-flex size-10 shrink-0 items-center justify-center rounded-md border border-border bg-card text-foreground shadow-sm hover:bg-secondary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring",
        className,
      )}
    >
      <Icon aria-hidden="true" className="size-6 rtl:-scale-x-100" />
    </button>
  );
}
